import { reactive, ref } from "vue";

// Global state for the auth modal
const isModalVisible = ref(false);
const modalConfig = reactive({
  title: "Sign In to Save Your Work",
  message:
    "Join thousands of Kenyan entrepreneurs who trust our platform to manage their business calculations and stay KRA-compliant.",
  returnUrl: null,
});

export function useKenyanAuthModal() {
  const showAuthModal = (config = {}) => {
    // Update modal configuration
    modalConfig.title = config.title || "Sign In to Save Your Work";
    modalConfig.message =
      config.message ||
      "Join thousands of Kenyan entrepreneurs who trust our platform to manage their business calculations and stay KRA-compliant.";
    modalConfig.returnUrl = config.returnUrl || null;

    // Show the modal
    isModalVisible.value = true;
  };

  const hideAuthModal = () => {
    isModalVisible.value = false;
  };

  // Predefined configurations for different save contexts
  const showTaxCalculatorAuthModal = (returnUrl = null) => {
    showAuthModal({
      title: "Save Your Tax Calculations",
      message:
        "Secure your valuable tax calculations and access them anytime. Join thousands of Kenyan businesses using our KRA-compliant platform to streamline their tax management.",
      returnUrl,
    });
  };

  const showProjectAuthModal = (returnUrl = null) => {
    showAuthModal({
      title: "Save Your Project",
      message:
        "Keep your project data safe and accessible. Join successful Kenyan businesses who rely on our platform to manage their projects and stay organized.",
      returnUrl,
    });
  };

  const showInvoiceAuthModal = (returnUrl = null) => {
    showAuthModal({
      title: "Save Your Invoice Draft",
      message:
        "Create KRA-compliant invoices with confidence. Save your invoice templates and access them whenever you need to bill your clients professionally.",
      returnUrl,
    });
  };

  const showExportAuthModal = (returnUrl = null) => {
    showAuthModal({
      title: "Sign In to Export Your Report",
      message:
        "Create an account or sign in to export your tax calculation reports as PDF or Excel. Access your reports anytime and stay KRA-compliant.",
      returnUrl,
    });
  };

  return {
    // State
    isModalVisible,
    modalConfig,

    // Methods
    showAuthModal,
    hideAuthModal,

    // Context-specific methods
    showTaxCalculatorAuthModal,
    showProjectAuthModal,
    showInvoiceAuthModal,
    showExportAuthModal,
  };
}
